// extracted by mini-css-extract-plugin
module.exports = {"main":"FlowContainer_main__1AzkI","default":"FlowContainer_default__68ZWp","large":"FlowContainer_large__8DnSm"};